module.exports = __webpack_public_path__ + "static/media/caret-t.9c948b27.svg";